import app from '~/plugins/vue-instance'
import INikanWait, { INikanWaitOptions } from '@/interfaces/plugins/nikan-waiting-plugin'
import { defineComponent, createApp, ComponentPublicInstance, App, Plugin } from 'vue'
import TabOrder from '../statics/taborder-functions'
import _ from 'lodash'
import { globalLogger } from './logger'
import $ from 'jquery'

class _NikanWait implements INikanWait {
  loggingEnabled: boolean
  el?: HTMLElement | null
  jel?: JQuery<HTMLElement> | null
  component?: ComponentPublicInstance | null
  focusedEl?: any | null
  reservedFocusedEl?: any | null
  _started?: boolean
  _destroyed?: boolean
  _ended: boolean
  options?: INikanWaitOptions

  constructor(el: HTMLElement | null, options?: INikanWaitOptions) {
    this.loggingEnabled = false
    this.el = el
    this.jel = el ? $(el) : null
    this.component = null
    this.focusedEl = null
    this.reservedFocusedEl = null
    this._started = false
    this._destroyed = false
    this._ended = false

    this.options = $.extend({
      size: 'default',
      color: '#FFFFFF',
      dimColor: 'rgba(0,0,0,.3)'
    }, options)
  }

  _validate() {
    if (this._destroyed) {
      globalLogger.warn('NikanWait object is destroyed. You cannot access it.')
      return false
    }

    if (this.el == null || this.jel == null) {
      globalLogger.warn('Waiting host is not defined.')
      return false
    }

    return true
  }
  _destroy() {
    this._destroyed = true
    if (this.component && _.isFunction(this.component.$options.unmount)) {
      this.component.$options.unmount()
    }

    delete this.el
    delete this.jel
    delete this.component
    delete this.focusedEl
    delete this._started
    delete this._destroyed
    delete this.options
  }
  _loadVm() {
    if (!this._validate()) {
      return
    }

    return new Promise<typeof import('../components/general/nikan-waiting.vue').default>((resolve, reject) => {
      import('../components/general/nikan-waiting.vue')
        .then(response => {
          resolve(response.default)
        })
        .catch(error => {
          globalLogger.error(error)
        })
    })
  }
  _catchFocus() {
    if (!this._validate()) {
      return
    }

    if (this.component == null) {
      return
    }

    var focused = this.jel?.find(':focus')
    if (focused && !focused.length && this.jel?.is(':focus')) {
      focused = this.jel
    }

    if (focused && focused.length > 0 && this.jel?.hasClass('nk-waiting-holder')) {
      this.focusedEl = focused
      this.component.$el.focus()
    } else {
      this.focusedEl = null
    }
  }
  _returnFocus() {
    if (!this._validate()) {
      return
    }

    var el = this.focusedEl
    var elExists = el != null && $(el).length > 0

    if (!elExists) {
      if (this.reservedFocusedEl == null) {
        return
      } else {
        el = this.reservedFocusedEl
      }
    }

    if (el != null) {
      if (_.isElement(el)) {
        el.focus()
      } else {
        el[0].focus()
      }
    }
  }
  _handleKeys() {
    if (!this._validate()) {
      return
    }

    // @ts-ignore
    app.$keyHandler.Subscribe({
      name: 'waiting-prevent-working',
      el: this.component?.$el,
      context: this,
      handler: function () {
        return true
      }
    })
  }
  _log(msg: string) {
    if (this.loggingEnabled) {
      console.log(msg)
    }
  }

  start() {
    this._log('waiting started')

    if (!this._validate()) {
      return
    }

    if (this._started) {
      return
    }

    this._started = true

    var _this = this

    this._loadVm()
      ?.then(Template => {
        if (this._ended) {
          return
        }

        if (_this.jel?.hasClass('nk-waiting-holder')) {
          return
        }

        const wait = defineComponent({
          extends: Template, props: {
            size: { type: String, default: _this.options?.size },
            // color: { type: String, default: _this.options?.color },
            color: { type: String, default: _this.options?.dimColor },
            bgColor: { type: String, default: _this.options?.bgColor },
            fixed: { type: Boolean, default: _this.options?.fixed },
          }
        })

        const div = document.createElement('div')
        _this.jel?.addClass('nk-waiting-holder')
        _this.jel?.attr('disabled', 'disabled')
        _this.jel?.append(div)
        this.component = createApp(wait).mount(div)
        _this.jel?.find('.draggable').css({ 'z-index': '998' })

        _this._catchFocus()
        _this._handleKeys()
        TabOrder.updateDisableds()
      })
  }
  end(el?: HTMLElement | null) {
    try {
      if (this._ended) {
        return
      }

      this._ended = true

      if (!this._validate()) {
        return
      }

      if (!this._started) {
        return
      }

      if (el) {
        this.reservedFocusedEl = el
      }

      this.jel?.find('.nk-waiting').remove()
      this.jel?.removeClass('nk-waiting-holder')
      this.jel?.removeAttr('disabled')

      this.jel?.find('.draggable').css({ 'z-index': 'auto' })

      TabOrder.updateDisableds()

      this._returnFocus()
      this._destroy()
      this._log('waiting ended')
    } catch (e) {
      globalLogger.error(e)
    }
  }
}

const NikanWait: Plugin = {

  install(app: App, options) {
    function wait(el: HTMLElement, options?: INikanWaitOptions) {
      var wait = new _NikanWait(el, options)

        wait.start()


      return wait
    }
    app.config.globalProperties.$wait = wait
  }
}

export default NikanWait
export { _NikanWait }
